/* ============================================================
   JUSTYOL — product card interactions (global, all card surfaces)
   - clickable variant-image swatches that swap the card image
     in place, without navigating to the product page
   ============================================================ */
(function () {
  'use strict';
  if (window.__jyCardJS) return;
  window.__jyCardJS = true;

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-jy-swatch-img]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();

    var card = sw.closest('.jy-pcard');
    if (!card) return;
    var img = card.querySelector('.jy-pcard__img--main');
    if (!img) return;

    var src = sw.getAttribute('data-jy-swatch-img');
    if (!src) return;

    // remember the original so we can keep it for the hover image, then swap
    if (!img.dataset.jyOrigSrc) img.dataset.jyOrigSrc = img.currentSrc || img.src;
    img.setAttribute('src', src);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    // active state among sibling swatches
    var group = sw.closest('.jy-pcard__swatches');
    if (group) {
      group.querySelectorAll('[data-jy-swatch-img]').forEach(function (s) {
        s.classList.toggle('is-active', s === sw);
      });
    }
  });
})();

/* ---- desktop quick-add: single-variant products go straight to the cart ---- */
(function () {
  'use strict';
  if (window.__jyQaddJS) return;
  window.__jyQaddJS = true;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-jy-qadd]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      var txt = btn.querySelector('.jy-pcard__add-txt');
      var old = txt ? txt.textContent : '';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.getAttribute('data-jy-qadd'), 10), quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          try {
            if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            }
          } catch (err) {
            /* noop */
          }
          if (txt) txt.textContent = '✓';
          setTimeout(function () {
            if (txt) txt.textContent = old;
            btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          btn.disabled = false;
          if (txt) txt.textContent = old;
        });
    },
    true
  );
})();
